import styles from './BtnSubmit.module.css';

export const BtnSubmit = ({ isActive, action, name, style, children }) => {
  return (
    <button
      type='submit'
      className={styles.btnSubmit}
      disabled={!isActive}
      onClick={(evt) => action(evt)}
      style={style}
    >
      {name}
      {children}
    </button>
  );
}